<template>
    <div class="value-chain">
        
        <div class="chain" v-if="data">

            <div class="chain__title">
                Værdikæde
                <div style="font-size:16px;display:inline-block;">
                    <d-tooltip placement="inline" identifier="index.valuechain" />
                </div>
            </div>

            <div class="links">

                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-file-alt fa-fw" />
                            {{ data.offer.count }}
                        </div>
                        Tilbud, der afventer afgørelse
                    </div>
                    <div class="coverage">
                        <span class="small">Potentielt DB</span>
                        {{ data.offer.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Potentiel omsætning</span>
                        {{ data.offer.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.offer.count > 0 ? ((data.offer.has_budget / data.offer.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.offer.has_budget }} / {{ data.offer.count }} opgaver har budget</span>
                    </div>
                </div>

                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-inbox-in fa-fw"/>
                            {{ data.open.count }}
                        </div>
                        opgaver, der ikke er påbegyndt
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.open.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.open.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.open.count > 0 ? ((data.open.has_budget / data.open.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.open.has_budget }} / {{ data.open.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-clock fa-fw"/>
                            {{ data.ongoing.count }}
                        </div>
                        igangværende opgaver,
                        <br>
                        der arbejdes på
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.ongoing.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.ongoing.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.ongoing.count > 0 ? ((data.ongoing.has_budget / data.ongoing.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.ongoing.has_budget }} / {{ data.ongoing.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-check-circle fa-fw"/>
                            {{ data.unbilled.count }}
                        </div>
                        afsluttede opgaver,
                        <br>
                        der ikke er fakturerede
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.unbilled.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.unbilled.expected_revenue | currency }}
                    </div>
                    <div class="budget" v-if="$auth.user().company.api_provider.slug === 'minuba'">
                        <span class="budget-bar-wrapper">
                            <span class="budget-bar-inner" :style="'width:' + (data.unbilled.count > 0 ? ((data.unbilled.has_budget / data.unbilled.count) * 100) : 0) + '%;'"></span>
                        </span>
                        <span class="small mt-1">{{ data.unbilled.has_budget }} / {{ data.unbilled.count }} opgaver har budget</span>
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-envelope-open-dollar fa-fw" />
                            {{ data.unpaid_invoices.count }}
                        </div>
                        fakturaer, der endnu ikke er betalt
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.unpaid_invoices.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.unpaid_invoices.expected_revenue | currency }}
                    </div>
                </div>
                <div class="link">
                    <div class="name">
                        <div class="icon">
                            <i class="fad fa-calendar-exclamation fa-fw" />
                            {{ data.overdue_invoices.count }}
                        </div>
                        fakturaer med overskredet betaling
                    </div>
                    <div class="coverage">
                        <span class="small">Forventet DB</span>
                        {{ data.overdue_invoices.expected_coverage | currency }}
                    </div>
                    <div class="revenue">
                        <span class="small">Forventet omsætning</span>
                        {{ data.overdue_invoices.expected_revenue | currency }}
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .budget {
        margin-top: $margin--small;

        .budget-bar-wrapper {
            display: block;
            width: 100%;
            height: 10px;
            background: #ddd;
            border-radius: 100px;
            overflow: hidden;

            .budget-bar-inner {
                display: block;
                height: 10px;
                width: 0px;
                background: #172b43;
            }
        }
    }

    .chain {
        background: $color--white;
        padding: $padding--main 0;
        // box-shadow: $boxshadow--creative;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: $borderradius--main;
        margin-bottom: $margin--main;
        // grid-column-gap: $margin--small;

        &__title {
            text-align: center;
            margin-bottom: $margin--main * 1.5;
            font-size: $fontsize--large;
            font-weight: 700;
        }

        .links {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
            // align-items: center;
        }

        .link {
            // text-align: center;
            position: relative;
            line-height: 1.5;
            padding: 0 $padding--main;
            font-size: $fontsize--sm;

            &:not(:last-of-type) {
                // border-right: 1px solid rgba(0, 0, 0, 0.05);

                &::before {
                    // content: "\f061";
                    content: "\f356";
                    font-family: "Font Awesome 5 Pro";
                    position: absolute;
                    top: 50%;
                    transform: translate(0, -50%);
                    right: 0;
                    color: $color--green;
                    font-weight: 700;
                    font-size: 24px;
                }
            }

            .name {
                font-size: $fontsize--main * 0.9;
                font-weight: 700;

                .icon {
                    font-size: $fontsize--large;
                    margin-bottom: $margin--small / 2;
                }

                > b {
                    font-weight: 700;
                }

                i {
                    /* font-size: $fontsize--large;
                    margin-bottom: $margin--small / 2; */
                }
            }

            .small {
                font-size: $fontsize--sm;
                display: block;
                font-weight: normal;
                color: $color--dark;
            }

            .revenue {
                font-weight: $fontweight--bold;
                margin-top: $margin--small;
                font-size: $fontsize--main;
                // font-size: $fontsize--medium;
            }

            .coverage {
                font-weight: $fontweight--bold;
                margin-top: $margin--small;
                font-size: $fontsize--medium;
                // color: $color--good;
            }
        }
    }

</style>

<script>
import * as calculationService from '@/services/calculationService'

export default {
    data () {
        return {
            loading: true,
            data: null
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            calculationService.valueChain(params, (response) => {
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            // let startDate = this.$store.getters.getStartDate
            // let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// valueChain.vue?6a0af2e2